<h4 class="heading" trans="language.choose"></h4>
<div class="option-list">
  @for (option of options; track option.code) {
    <button type="button" class="option" (click)="pickLanguage(option.code)" (keypress.enter)="pickLanguage(option.code)">
      <span class="checkmark">
        @if (option.code === language) {
          <mat-icon>check</mat-icon>
        }
      </span>
      <span>
        <img class="flag" [src]="getFlag(option.flag)" alt="">
      </span>
      @if (option.endonym === option.exonym) {
        <span>{{option.endonym}}</span>
      } @else {
        <span>{{option.endonym}} ({{option.exonym}})</span>
      }
    </button>
  }
</div>
